import { IMealGroup, IMealGroups } from '../../interfaces/mealGroup';
import { IMeal } from '../../interfaces/meal';
import { Meal, Meals } from "./meal";
import { Food } from "./food";

export class MealGroup implements IMealGroup {
  _id: string;
  meals: IMeal[];
  key: string;
  value: string;

  constructor(item: IMealGroup) {
    Object.keys(item).forEach((key) => {
      if (key === 'meals') {
        this[key] = new Meals(item[key]).meals;
      } else {
        this[key] = item[key as keyof MealGroup];
      }
    });
  }

  getTotal(key: string): string {
    return this.meals.reduce((acc: number, value: IMeal) => {
      return acc + (+value.calculate(key) || 0)
    }, 0).toFixed(1)
  }

  appendMeal(toAddArray: {measureValue: number, measureOption: string, item: Food}[]) {
    toAddArray.forEach((toAdd) => {
      const measure = toAdd.item.measures.find((measure) => measure.label.toLowerCase() === toAdd.measureOption.toLowerCase())
      const meal = new Meal({
        _id: null,
        externalId: toAdd.item.food.foodId,
        name: toAdd.item.food.label,
        measurement: toAdd.measureOption,
        count: toAdd.measureValue,
        weight: measure.weight,
        fat: +toAdd.item.food.nutrients.FAT,
        carb: +toAdd.item.food.nutrients.CHOCDF,
        prot: +toAdd.item.food.nutrients.PROCNT,
        kcal: +toAdd.item.food.nutrients.ENERC_KCAL,
      })
      this.meals.push(meal)
    })
  }

  removeMeal(mealId: string) {
    this.meals.forEach((meal,index)=>{
      if(meal._id === mealId) this.meals.splice(index,1);
    });
  }

  removeMealByExternalId(externalId: string) {
    this.meals.forEach((meal,index)=>{
      if(meal.externalId === externalId) this.meals.splice(index,1);
    });
  }
}

export class MealGroups implements IMealGroups {
  mealGroups: IMealGroup[];

  constructor(items: IMealGroup[]) {
    this.mealGroups = items.map((item) => new MealGroup(item));
  }
}
